import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FilterGroupProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function FilterGroup({
  title,
  children,
  defaultOpen = true
}: FilterGroupProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="border-b border-slate-100 last:border-0 pb-4 mb-4 last:pb-0 last:mb-0" data-id="element-84">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center justify-between w-full py-2 text-left" aria-expanded={isOpen} data-id="element-85">
        <span className="text-sm font-semibold text-slate-800" data-id="element-86">{title}</span>
        <motion.span animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-87">
          <ChevronDownIcon className="w-5 h-5 text-slate-400" data-id="element-88" />
        </motion.span>
      </button>
      <AnimatePresence initial={false} data-id="element-89">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden" data-id="element-90">
            <div className="pt-3" data-id="element-91">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface CheckboxFilterProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  count?: number;
}
export function CheckboxFilter({
  label,
  checked,
  onChange,
  count
}: CheckboxFilterProps) {
  return <label className="flex items-center gap-3 py-1.5 cursor-pointer group" data-id="element-92">
      <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} className="w-4 h-4 rounded border-slate-300 text-sky-500 focus:ring-sky-500 focus:ring-offset-0" data-id="element-93" />
      <span className="text-sm text-slate-600 group-hover:text-slate-900 transition-colors flex-1" data-id="element-94">
        {label}
      </span>
      {count !== undefined && <span className="text-xs text-slate-400" data-id="element-95">{count}</span>}
    </label>;
}
interface PriceRangeFilterProps {
  min: number;
  max: number;
  value: [number, number];
  onChange: (value: [number, number]) => void;
}
export function PriceRangeFilter({
  min,
  max,
  value,
  onChange
}: PriceRangeFilterProps) {
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('uk-UA').format(price);
  };
  return <div className="space-y-4" data-id="element-96">
      <div className="flex items-center gap-3" data-id="element-97">
        <div className="flex-1" data-id="element-98">
          <label className="text-xs text-slate-500 mb-1 block" data-id="element-99">Від</label>
          <input type="number" value={value[0]} onChange={e => onChange([Number(e.target.value), value[1]])} min={min} max={value[1]} className="w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500" data-id="element-100" />
        </div>
        <span className="text-slate-400 mt-5" data-id="element-101">—</span>
        <div className="flex-1" data-id="element-102">
          <label className="text-xs text-slate-500 mb-1 block" data-id="element-103">До</label>
          <input type="number" value={value[1]} onChange={e => onChange([value[0], Number(e.target.value)])} min={value[0]} max={max} className="w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500" data-id="element-104" />
        </div>
      </div>
      <input type="range" min={min} max={max} value={value[1]} onChange={e => onChange([value[0], Number(e.target.value)])} className="w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-sky-500" data-id="element-105" />
      <div className="flex justify-between text-xs text-slate-500" data-id="element-106">
        <span data-id="element-107">{formatPrice(min)} ₴</span>
        <span data-id="element-108">{formatPrice(max)} ₴</span>
      </div>
    </div>;
}